var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"scrollbox",staticClass:"scrollbox"},[_c(_vm.contentTag,{tag:"DynamicTag",class:_vm.contentClass},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }